import { render, staticRenderFns } from "./PanelistSurveyAlternativePage.vue?vue&type=template&id=a8ec1370"
import script from "./PanelistSurveyAlternativePage.vue?vue&type=script&lang=ts"
export * from "./PanelistSurveyAlternativePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports